import { capitalize } from 'lodash';

const productTitleFromSlug = (slug) => {
    slug = capitalize(slug);

    return slug.replace(/-/g, ' | ')
        .replace(/Pelp/g, 'PELP')
        .replace(/Grandprotect/g, 'GrandProtect')
        .replace(/agent360/g, 'Agent360')
        .replace(/ars/g, 'ARS');
};

export default productTitleFromSlug;
